import { InventoryStateTypes, InventoryActionTypes } from "./Inventory.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: InventoryStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchAllQueried: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
  fetchStockCard: resetApiCallState([]),
};

const InventoryReducer = (
  state: InventoryStateTypes = INITIAL_STATE,
  action: any
): InventoryStateTypes => {
  switch (action.type) {
    case InventoryActionTypes.FETCH_ALL_INVENTORY:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case InventoryActionTypes.FETCH_ALL_INVENTORY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case InventoryActionTypes.FETCH_ALL_INVENTORY_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case InventoryActionTypes.FETCH_ALL_INVENTORY_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // ----------------------------

    case InventoryActionTypes.FETCH_ALL_QUERIED_INVENTORY:
      return {
        ...state,
        fetchAllQueried: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case InventoryActionTypes.FETCH_ALL_QUERIED_INVENTORY_RESET:
      return {
        ...state,
        fetchAllQueried: resetApiCallState([]),
      };
    case InventoryActionTypes.FETCH_ALL_QUERIED_INVENTORY_FAILURE:
      return {
        ...state,
        fetchAllQueried: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case InventoryActionTypes.FETCH_ALL_QUERIED_INVENTORY_SUCCESS:
      return {
        ...state,
        fetchAllQueried: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // ----------------------------

    case InventoryActionTypes.FETCH_ONE_INVENTORY:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case InventoryActionTypes.FETCH_ONE_INVENTORY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case InventoryActionTypes.FETCH_ONE_INVENTORY_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case InventoryActionTypes.FETCH_ONE_INVENTORY_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // ----------------------------

    case InventoryActionTypes.FETCH_INVENTORY_STOCK_CARD:
      return {
        ...state,
        fetchStockCard: {
          error: null,
          payload: {
            stock_card: [],
            summery: {
              total_issued: 0,
              total_received: 0,
              total_returned: 0,
              total_transferred: 0,
              unit_price: 0,
            },
          },
          isPending: true,
          isSuccessful: false,
        },
      };
    case InventoryActionTypes.FETCH_INVENTORY_STOCK_CARD_RESET:
      return {
        ...state,
        fetchStockCard: resetApiCallState([]),
      };
    case InventoryActionTypes.FETCH_INVENTORY_STOCK_CARD_FAILURE:
      return {
        ...state,
        fetchStockCard: {
          payload: {
            stock_card: [],
            summery: {
              total_issued: 0,
              total_received: 0,
              total_returned: 0,
              total_transferred: 0,
              unit_price: 0,
            },
          },
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case InventoryActionTypes.FETCH_INVENTORY_STOCK_CARD_SUCCESS:
      return {
        ...state,
        fetchStockCard: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -----------------------------

    default:
      return state;
  }
};

export default InventoryReducer;
